import React, { useEffect } from "react";
import OrderStatusOverview from "./OrderStatusOverview";
import PaymentCancelCard from "./PaymentCancelCard";
import DriverCard from "./DriverCard";
import PoiInfoCard from "./PoiInfoCard";
import { useReceiptCardInfo } from "./handler/useReceiptCardInfo";
import { ICancelledCompleteComponentProps } from "./types";

const CancelledCompleteComponent: React.FC<
  ICancelledCompleteComponentProps
> = ({ orderStatus, data }) => {
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      if (isMobile) {
        document.body.style.overflow = "";
      }
    };
  }, []);
  const {
    cardType,
    cardNumber,
    pickupTime,
    updatedAtPOI,
    pickupDisplayName,
    pickupAddress,
    dropoffDisplayName,
    dropoffAddress,
    licensePlate,
    carModel,
    carMake,
    driverName,
    driverPhone,
    mainTitle,
    subTitle,
    timeInfo,
    total,
    carIcon,
    cancellationFee
  } = useReceiptCardInfo(orderStatus, data);

  if (orderStatus !== "completed" && orderStatus !== "cancelled") return null;

  const updatedAt = orderStatus === "completed" ? updatedAtPOI : "";

  return (
    <div className="bg-nobel-50 flex flex-col w-full min-h-screen">
      <div className="max-w-2xl w-full mx-auto">
        <OrderStatusOverview
          status={orderStatus}
          mainTitle={mainTitle}
          subtitle={subTitle}
          timeInfo={timeInfo}
        />
        <div className="mt-4">
          <PaymentCancelCard
            cardType={cardType}
            maskedPin={cardNumber}
            total={total}
            cancellationFee={cancellationFee}
            status={orderStatus === "cancelled" ? "cancelled" : "active"}
            txId={data?.id}
          />
        </div>
        {data?.driver?.licensePlate && (
          <DriverCard
            licensePlate={licensePlate}
            carModel={carModel}
            carMake={carMake}
            driverName={driverName}
            driverPhone={driverPhone}
            carImageUrl={carIcon}
            status={orderStatus}
          />
        )}
        <PoiInfoCard
          time={pickupTime}
          pickupPoi={pickupDisplayName}
          pickupAddress={pickupAddress}
          dropoffPoi={dropoffDisplayName}
          dropoffAddress={dropoffAddress}
          updatedAt={updatedAt}
        />
      </div>
    </div>
  );
};

export default CancelledCompleteComponent;
